import * as React from 'react';
import { Input } from 'antd';
import type { DynamicComponentProps } from '@/types/commontypes';

interface InputBoxProps extends DynamicComponentProps<string | number> {
  type?: 'string' | 'number';
  style?: React.CSSProperties;
  disabled?: boolean;
  step?: string;
  min?: string;
}

const InputBox: React.FC<InputBoxProps> = ({ label, value, onChange, type = 'text', style, ...props }) => {
  return (
    <div>
      <label>{label}</label>
      <Input
        value={value}
        onChange={e => onChange(e.target.value)}
        type={type}
        style={{ width: '100%', ...style }}
        {...props}
        disabled={props.disabled}
      />
    </div>
  );
};

export default InputBox;
